import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const KentuckyMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg
			id='kentucky'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 1000 1000'
			className='map'>
			<polygon
				id='KY_ZS'
				points='906.25 482.7 888.64 502.62 850.57 527.43 829.35 548.73 817.74 569.25 789.47 591.58 753.64 611.41 761.8 616.56 421.8 624.07 246.05 620.3 238.65 642.12 107.65 637.64 93.75 624.97 114.97 621.02 122.97 593.2 121.52 564.42 126.08 544.92 142.92 534.9 161.73 544.16 178.3 560.58 197.63 558.18 202.44 544.78 193.95 525.71 214.74 508.71 230.89 503.39 238.29 490.25 906.25 482.7'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'KY_ZS' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('KY_ZS')}
			/>
			<polygon
				id='KY_ZN'
				points='906.25 482.7 882.47 460.36 850.7 422.46 836.35 392.54 839.56 360.61 808.82 329.76 790.87 318.41 769.99 327.6 671.21 317.68 646.48 287.43 625.62 270.59 593.83 267.39 584.38 275.12 586.7 286.63 592.1 301.93 584.62 315.92 572.34 325.97 551.12 329.91 531.53 326.21 518.72 358.76 479.62 402.56 474.11 420.22 460.96 432.78 449.28 428.14 439.58 421.09 430.13 411.47 419.74 414.76 403.49 443.5 392.93 445.04 376.26 438.16 363.98 439.53 351.35 453.01 333.31 451.2 318.62 441.92 291.22 446.98 247.58 458.21 243.02 469.03 238.29 490.25 906.25 482.7'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'KY_ZN' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('KY_ZN')}
			/>
			<rect
				x='626.26'
				y='330.86'
				width='72.17'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M625.65,370.39l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M659.51,373.46l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<rect x='657.35' y='537.45' width='63.3' height='43.33' fill='none' className='shape' />
			<path
				d='M656.73,576.98l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M691.22,573.8c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<polygon
				points='497.93 397.43 498.04 401.76 502.59 401.76 498.11 404.43 498.21 408.75 495.34 406.08 490.86 408.75 493.56 404.43 490.68 401.76 495.23 401.76 497.93 397.43'
				className='shape'
			/>
			<rect x='501.6' y='380.47' width='113.23' height='20' fill='none' className='shape' />
			<path
				d='M505.42,381.33h1.99l-2.76,14.45h6.53l-.33,1.73h-8.5l3.08-16.18Z'
				className='shape'
			/>
			<path
				d='M525.82,390.46c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.15-4.53-4.77,0-3.84,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM516.9,392.92c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.74,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M540.96,385.9l-1.56,8.23c-.24,1.29-.41,2.42-.52,3.38h-1.8l.3-2.19h-.05c-1.03,1.51-2.56,2.46-4.1,2.46s-3.07-.72-3.07-3.36c0-.56.07-1.18.22-1.95l1.25-6.56h1.99l-1.23,6.47c-.12.64-.2,1.2-.2,1.7,0,1.2.49,2.02,1.85,2.02,1.45,0,3.3-1.69,3.78-4.24l1.13-5.95h1.99Z'
				className='shape'
			/>
			<path
				d='M544.68,397.51l2.22-11.61h1.99l-2.22,11.61h-1.99ZM547.27,382.66c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M552.7,395.49c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.86.56,1.37,1.6,1.96,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M566.56,385.9l1,6.61c.18,1.32.32,2.21.37,2.85h.07c.25-.62.56-1.38,1.24-2.7l3.54-6.76h2.18l-6.46,11.61h-1.96l-2.01-11.61h2.03Z'
				className='shape'
			/>
			<path
				d='M577.32,397.51l2.22-11.61h1.99l-2.22,11.61h-1.99ZM579.91,382.66c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path d='M585.25,397.51l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path d='M593.17,397.51l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M609.45,396.84c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.8l.29,1.48ZM607.25,387.18c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<polygon
				points='664.23 416.63 664.33 420.95 668.88 420.95 664.4 423.63 664.51 427.95 661.63 425.28 657.15 427.95 659.85 423.63 656.98 420.95 661.52 420.95 664.23 416.63'
				className='shape'
			/>
			<rect x='667.89' y='399.66' width='115.47' height='20' fill='none' className='shape' />
			<path
				d='M671.72,400.53h1.99l-2.76,14.45h6.53l-.33,1.73h-8.5l3.08-16.18Z'
				className='shape'
			/>
			<path
				d='M689.35,416.04c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM687.15,406.38c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M697.21,405.1l1.13,2.53c.33.75.55,1.32.78,1.86h.07c.44-.64.71-1.05,1.27-1.76l2.14-2.63h2.3l-4.89,5.65,2.75,5.96h-2.17l-1.17-2.62c-.39-.87-.57-1.31-.84-2.07h-.07c-.34.55-.69,1.1-1.19,1.78l-2.35,2.92h-2.31l5.1-5.98-2.7-5.63h2.16Z'
				className='shape'
			/>
			<path
				d='M707.24,416.7l2.22-11.61h1.99l-2.22,11.61h-1.99ZM709.82,401.85c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.79-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M715.16,416.7l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M730.5,419.34c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM739.42,406.82c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<path
				d='M750.59,401.98l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.13-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M766.37,409.66c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM757.45,412.12c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M770.19,416.7l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.93.79,2.93,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<polygon
				points='435.57 541.81 435.68 546.13 440.22 546.13 435.74 548.8 435.85 553.13 432.98 550.46 428.5 553.13 431.2 548.8 428.32 546.13 432.87 546.13 435.57 541.81'
				className='shape'
			/>
			<rect x='439.24' y='524.84' width='171.71' height='20' fill='none' className='shape' />
			<path
				d='M443.01,525.93c.99-.2,2.15-.33,3.47-.33,1.67,0,2.87.34,3.73,1.11.75.61,1.16,1.47,1.16,2.52,0,2.04-1.65,3.56-3.48,4.04v.06c1.46.43,2.67,1.64,2.65,3.59,0,1.66-.88,2.96-1.94,3.75-1.28.96-3.07,1.33-5.24,1.33-1.39,0-2.6-.08-3.35-.23l2.99-15.83ZM442.24,540.27c.51.08,1.09.1,1.64.1,2.36.01,4.57-.97,4.57-3.56,0-1.9-1.6-2.73-3.42-2.73h-1.62l-1.17,6.19ZM443.73,532.57h1.48c2.32,0,4.11-1.2,4.11-3.17,0-1.56-1.18-2.22-2.94-2.22-.73,0-1.34.05-1.65.15l-1,5.24Z'
				className='shape'
			/>
			<path
				d='M466.01,534.84c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM457.08,537.3c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M472.4,530.27l.41,6.53c.09,1.43.08,2.18.06,3.12h.05c.28-.76.7-1.75,1.27-2.91l3.45-6.74h1.73l.73,6.61c.12,1.28.2,2.27.18,3.04h.06c.31-.94.63-1.83,1.1-2.95l3.13-6.7h2.03l-5.74,11.61h-1.85l-.77-6.31c-.11-1.08-.18-2.07-.17-3.09h-.05c-.49,1.12-.82,2-1.35,3.03l-3.33,6.37h-1.86l-1.07-11.61h1.96Z'
				className='shape'
			/>
			<path d='M489.05,541.88l3.25-17.04h1.99l-3.25,17.04h-1.99Z' className='shape' />
			<path
				d='M496.96,541.88l2.22-11.61h1.99l-2.22,11.61h-1.99ZM499.55,527.03c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.79-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M504.88,541.88l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M520.23,544.52c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM529.15,532c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<path
				d='M553.89,541.19c-.94.37-2.66.86-4.56.86-2.28,0-4.06-.65-5.29-2.02-1.23-1.35-1.63-3.12-1.63-4.72,0-2.68,1.09-5.49,3.16-7.36,1.73-1.52,4.06-2.4,6.65-2.4,1.99,0,3.33.45,3.82.74l-.66,1.68c-.82-.42-1.94-.7-3.4-.7-1.9,0-3.66.71-5.01,1.97-1.51,1.41-2.43,3.73-2.43,5.92,0,3.12,1.57,5.19,5.16,5.19.96,0,1.87-.19,2.46-.46l.92-4.83h-3.27l.31-1.63h5.23l-1.46,7.77Z'
				className='shape'
			/>
			<path
				d='M559.31,541.88l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M577.6,541.21c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM575.4,531.56c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M590.92,541.21c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM588.72,531.56c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M595.84,541.88l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<polygon
				points='313.72 447.94 313.83 452.26 318.37 452.26 313.9 454.94 314 459.26 311.13 456.59 306.65 459.26 309.35 454.94 306.47 452.26 311.02 452.26 313.72 447.94'
				className='shape'
			/>
			<rect x='317.39' y='430.97' width='132.08' height='20' fill='none' className='shape' />
			<path
				d='M333.17,438.2c0,2.8-1.03,5.9-2.95,7.81-1.43,1.42-3.31,2.26-5.54,2.26-4.18,0-6.13-3.15-6.13-6.58,0-2.84,1.11-6,3.08-7.93,1.39-1.35,3.39-2.19,5.42-2.19,4.35,0,6.12,3.17,6.12,6.63ZM323.09,434.87c-1.56,1.56-2.46,4.4-2.46,6.66,0,2.63,1.17,5.06,4.33,5.06,1.38,0,2.69-.6,3.69-1.62,1.53-1.53,2.41-4.44,2.41-6.69s-.75-5.04-4.29-5.04c-1.44,0-2.7.63-3.7,1.62Z'
				className='shape'
			/>
			<path
				d='M339.7,436.4l.41,6.53c.09,1.43.08,2.18.06,3.12h.05c.28-.76.7-1.75,1.27-2.91l3.45-6.74h1.73l.73,6.61c.12,1.28.2,2.27.18,3.04h.06c.31-.94.63-1.83,1.1-2.95l3.13-6.7h2.03l-5.74,11.61h-1.85l-.77-6.31c-.11-1.08-.18-2.07-.17-3.09h-.05c-.49,1.12-.82,2-1.35,3.03l-3.33,6.37h-1.86l-1.07-11.61h1.96Z'
				className='shape'
			/>
			<path
				d='M364.53,447.35c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM362.33,437.69c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M369.45,448.01l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.17-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M384.79,445.99c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.9,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.96,1.29.73,2.17,1.74,2.17,3.05,0,2.44-1.98,3.83-4.43,3.83-1.25,0-2.36-.39-2.89-.8l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M401.18,430.97l-1.53,7.53h.05c1.03-1.55,2.52-2.36,4.08-2.36,2.54,0,3.52,2.1,3.52,4.16,0,3.57-2.58,7.98-7.23,7.98-2.04,0-3.58-.85-3.58-2.99,0-.57.1-1.25.2-1.8l2.5-12.51h1.99ZM398.67,443.52c-.08.39-.15.86-.14,1.47.01,1.1.64,1.71,1.88,1.71,3.01,0,4.82-3.57,4.82-6.15,0-1.44-.63-2.77-2.22-2.77-1.71,0-3.5,1.78-4.08,4.5l-.26,1.23Z'
				className='shape'
			/>
			<path
				d='M422.3,440.97c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM413.38,443.43c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M426.11,448.01l1.42-7.48c.28-1.51.46-3.05.59-4.13h1.75c-.09.81-.19,1.62-.32,2.52h.07c.76-1.59,2-2.79,3.56-2.79.18,0,.41.01.57.04l-.39,1.96c-.14-.03-.32-.04-.54-.04-1.72,0-3.26,2.09-3.76,4.79l-.96,5.12h-1.99Z'
				className='shape'
			/>
			<path
				d='M447.17,440.97c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM438.24,443.43c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
		</svg>
	);
};

KentuckyMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default KentuckyMap;
